export default {
    parameters: {
        landing_id: "pABd",
    },
    downtimeUrl: "https://it.kodland.tech",
    startPage: {
      image: {
        url:  "/welcome/quiz_poland_live_ptincipal_free_course_pk.png",
        style: {
            height: "100%",
            "max-height": "100vh",
        },
      },
      imageMobile: {
        url: "/welcome/quiz_poland_live_ptincipal_free_course_mobile.png",
        style: {
            width: "100%",
        },
      },
      title:
        "Odpowiedz na tylko 4 pytania i weź udział w BEZPŁATNYM KURSIE",
      subtitle:
        "<b>Zajęcia są prowadzone w języku polskim!</b> Twoje dziecko stworzy własny projekt.",
      button: "Ruszajmy 🚀",
    },
    stopPage: {
        image: "/welcome/quiz_stop_page.jpg",
        title: "Dziękujemy za zaufanie do naszej platformy edukacyjnej! Niestety nasze lekcje mogą się odbywać tylko na komputerach, a tablety i telefony komórkowe nie są odpowiednie do odbycia naszych zajęć. Mamy jednak nadzieję, że zobaczymy się na naszych zajęciach innym razem!",
    },
    quizRotateBySteps: {
      1: {
        question: "Ile czasu dziennie Twoje dziecko spędza używając gadżetów?",
        answers: [
            "😍 Do 2 godzin", 
            "🙂 Od 2 do 4 godzin",
            "😞 Więcej niż 4 godziny",
            "🤔 Nie pilnuję tego",
        ],
      },
      2: {
        question: "Jaki charakter ma Twoje dziecko?",
            answers: [
                {
                  answer: "Aktywne, bardzo rozmowne",
                  img: "/welcome/quiz_poland_live_ptincipal_free_course_q2a1.webp",
                  isImage: true,
                  answerIsNull: false,
                },
                {
                  answer: "Nieśmiałe, często się wstydzi",
                  img: "/welcome/quiz_poland_live_ptincipal_free_course_q2a2.webp",
                  isImage: true,
                  answerIsNull: false,
                },
                {
                  answer: "Marzycielskie, oddaje się marzeniom",
                  img: "/welcome/quiz_poland_live_ptincipal_free_course_q2a3.webp",
                  isImage: true,
                  answerIsNull: false,
                },
                {
                  answer: 'Ciche, spędza czas "w sobie"',
                  img: "/welcome/quiz_poland_live_ptincipal_free_course_q2a4.webp",
                  isImage: true,
                  answerIsNull: false,
                },
                {
                  answer: "Nie wie czego chce",
                  img: "/welcome/quiz_poland_live_ptincipal_free_course_q2a5.webp",
                  isImage: true,
                  answerIsNull: false,
                },
                {
                  answer: "Własna wersja, opowiem na lekcji",
                  img: "/welcome/quiz_poland_live_ptincipal_free_course_q2a6.webp",
                  isImage: true,
                  answerIsNull: false,
                },
            ],
        },        
      3: {
        question: "Na czym zależy Ci najbardziej?",
        answers: [
          "👩‍👧 Nawiązanie kontaktu z dzieckiem",
          "🎣 Natychmiastowe rezultaty",
          "🧠 Zainteresowanie i motywacja dziecka",
          "👏🏼 Przydatne umiejętności w przyszłości",
          "😻 Przyjazna atmosfera",
          "🖥️ Wygodna platforma edukacyjna"
        ],
      },
      4: {
        question: "Jak oceniasz poziom motywacji Twojego dziecka?",
        answers: [
          "😞 Niski",
          "🤔 Średni",
          "😍 Wysoki",
        ],
      },
      5: {
        title: "Ile lat ma Twoje dziecko?",
        type: "age",
        subtitle: "Dostosujemy najciekawszy kurs odpowiednio do wieku Twojego dziecka",
        button: "Dalej",
      },
      6: {
        question: "Czy posiadasz komputer stacjonarny/laptopa, z którego Twoje dziecko może skorzystać?",
        answers: [
          "✔️ Tak",
          {
            answer: "❌ Nie",
            stopAnswer: true
          },
        ],
      },
      7: {
        title: "Kiedy możesz uczestniczyć w lekcji próbnej?",
        type: "timeslot",
        subtitle:
          "Pozostało tylko kilka kroków, aby zapisać się na indywidualną lekcję! Nie możemy się doczekać spotkania z Tobą🥳",
        button: "Dalej",
      },
      8: {
        title: "Jak ma na imię Twoje dziecko?",
        type: "child_name",
        subtitle:
          "Dane są chronione i zostaną usunięte na Twoje życzenie 🚨",
        button: "Dalej",
      },
      9: {
        title: "Podaj swój adres e-mail",
        type: "mail",
        subtitle: "Nie martw się, nie dostaniesz niechcianych wiadomości 😅",
        button: "Dalej",
      },
      10: {
        title: "Podaj swój numer telefonu",
        type: "phone",
        subtitle: "Będziemy kontaktować z Tobą tylko w ważnych sprawach 📞",
        button: "Dalej",
      },
      11: {
        title: "Podaj swoje imię",
        type: "parent_name",
        subtitle: "Nasza szkoła to - Kodland, a Ty jak masz na imię? 👋",
        button: "Zakończyć rejestrację",
      },
    },
  };
  